import { Category } from '@isophi/core-legacy';
import { Evaluation } from './evaluation.model';

export class SortedReportCategoryResult {
  constructor(public category: Category, public evaluation: Evaluation | null, public percentScore: number) {}
}
